module.exports = __webpack_public_path__ + "20bdc808cf3144afb68e0f6e46bdacb3.svg";